import React from "react";

const SVG = ({
  style = {},
  fill = "#000",
  className = "",
  width = "100%",
  height = "100%",
  viewBox = "0 0 24 24",
}) => (
  <svg
    style={style}
    width={width}
    height={height}
    viewBox={viewBox}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.77405 19.6475C7.93939 20.8673 9.10133 21.8592 9.97082 22.5458L12 24L14.0292 22.5458C14.8987 21.8592 16.0606 20.8673 17.226 19.6475C19.5157 17.2507 22 13.786 22 9.9166C22 7.28655 20.9464 4.76423 19.0711 2.9045C17.1957 1.04478 14.6522 0 12 0C9.34784 0 6.8043 1.04478 4.92893 2.9045C3.05357 4.76423 2 7.28655 2 9.9166C2 13.786 4.48426 17.2507 6.77405 19.6475ZM12 1.98332C9.87827 1.98332 7.84344 2.81914 6.34315 4.30692C4.84285 5.7947 4 7.81256 4 9.9166C4 12.9888 6.01574 15.9699 8.22595 18.2835C9.31061 19.4189 10.3987 20.3483 11.2167 20.9943C11.5211 21.2347 11.787 21.4349 12 21.591C12.213 21.4349 12.4789 21.2347 12.7833 20.9943C13.6013 20.3483 14.6894 19.4189 15.774 18.2835C17.9843 15.9699 20 12.9888 20 9.9166C20 7.81256 19.1571 5.7947 17.6569 4.30692C16.1566 2.81914 14.1217 1.98332 12 1.98332Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8ZM8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
